import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';

export default {
  attributeName: 'device-configs-usage',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: true,
  removeURL: 'configs/devices',
  getURL: 'configs/devices',
  idAttribute: 'id',
  fetchOnMount: true,
  sessionParams: [],
  emptyMessage: "This device is not used in any config.",
  fields: [
    {
      attributeName: 'id',
      label: 'Config ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The configuration ID',
      canFilter: true,
      canEdit: false,
      width: '8rem',
    },
    {
      attributeName: 'config_name',
      label: 'Config Name',
      helpText: 'Main Hub Config or App Config name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canFilter: true,
      canEdit: false,
      width: '8rem',
    },
    {
      attributeName: 'mainhub_name',
      label: 'White Label Pro',
      helpText: 'Main Hub (White Label Pro) name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canFilter: true,
      canEdit: false,
      width: '10rem',
    },
    {
      attributeName: 'app_name',
      label: 'White Label Play',
      helpText: 'App (White Label Play) name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canFilter: true,
      canEdit: false,
      width: '10rem',
    },
    {
      attributeName: 'min_build',
      label: 'Min Build',
      helpText: 'Minimum build number',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canFilter: true,
      canEdit: false,
      width: '12rem',
    },
    {
        attributeName: 'link',
        label: 'Link to White Label Play/Pro',
        type: FormInputTypes.LINK,
        icon: IconType.LINK,
        helpText: 'Link to White Label Play/Pro',
        canOrder: false,      
        canFilter: false,
      },
  ],
};
